import api from '../api'
import { createStore } from 'vuex'

const currentUrl = window.location.href
let baseDomain = 'fitbase.io'

if (
    currentUrl.includes('devops')
    || currentUrl.includes('192.168')
    || currentUrl.includes('http://demo.fitbase.local/')
) {
    baseDomain = 'devops.fitbase.io'
}

export default createStore({
    state(){
        return {
            token: '',
            baseDomain: baseDomain,
            subDomain: '',
            user: {},
            reservations: [],
            finishedReservations: [],
            reservationsTab: 'active',
            contracts: [],
            services: [],
            finishedContracts: [],
            finishedServices: [],
            showPreloader: false,
            showModalPreloader: false,
            isMenuOpened: false,
            settings: {
                lk: {
                    app_links: {},
                    logo: null
                }
            },
            shopItemContractModal: false,
            shopItemServiceModal: false,
            shopPaymentModal: false,
            shopSuccessModal: false,
            shopSales: [],
            shopMainCategories: [],
            itemCancelSubscriptionModal: false,
            successModal: false,
            successMessage: '',
        }
    },
    getters: {
        token(state){
            return (state.token) ? state.token : ''
        },
        systemUrl(state){
            return 'https://'+ state.subDomain + '.' + state.baseDomain + '/'
        },
        showPreloader(state){
            return state.showPreloader
        },
        showModalPreloader(state){
            return state.showModalPreloader
        },
        isMenuOpened(state){
            return state.isMenuOpened
        },
        storeLinks(state){
            return (state.settings.lk) ? state.settings.lk.app_links : []
        },
        logoLinks(state){
            return (state.settings.lk.logo) ? state.settings.lk.logo : null
        },
        userId(state){
            return (state.user) ? state.user.id : ''
        },
        userName(state){
            return (state.user) ? state.user.name : ''
        },
        userEmail(state){
            if (state.user.contacts === undefined){
                return ''
            }
            let email = '';
            state.user.contacts.forEach(function (item) {
                if (item.contact_type === 'email'){
                    email = item.contact
                }
            })

            return email
        },
        userDeposit(state){
            return (state.user.deposit_full) ? state.user.deposit_full : null
        },
        reservations(state){
            return state.reservations
        },
        finishedReservations(state){
            return state.finishedReservations
        },
        reservationsTab(state){
            return state.reservationsTab
        },
        contracts(state){
            return state.contracts
        },
        services(state){
            return state.services
        },
        items(state){
            let contracts = state.contracts;
            let services = state.services;

            return contracts.concat(services);
        },
        finishedItems(state){
            let contracts = state.finishedContracts;
            let services = state.finishedServices;

            return contracts.concat(services);
        },
        settings(state){
            return state.settings;
        },
        shopItemContractModal(state){
            return state.shopItemContractModal
        },
        shopItemServiceModal(state) {
            return state.shopItemServiceModal
        },
        shopPaymentModal(state){
            return state.shopPaymentModal
        },
        shopSuccessModal(state){
            return state.shopSuccessModal
        },
        shopSales(state){
            return state.shopSales
        },
        shopMainCategories(state){
            return state.shopMainCategories
        },
        itemCancelSubscriptionModal(state) {
            return state.itemCancelSubscriptionModal
        },
        successModal(state) {
            return state.successModal
        },
        successMessage(state) {
            return state.successMessage
        },
    },
    mutations: {
        SHOW_PRELOADER(state){
            state.showPreloader = true
        },
        HIDE_PRELOADER(state){
            state.showPreloader = false
        },
        SHOW_MODAL_PRELOADER(state){
            state.showModalPreloader = true
        },
        HIDE_MODAL_PRELOADER(state){
            state.showModalPreloader = false
        },
        SHOW_MENU(state){
            document.body.style.overflow = 'hidden';
            state.isMenuOpened = true
        },
        HIDE_MENU(state){
            document.body.style.overflow = '';
            state.isMenuOpened = false
        },
        SET_TOKEN (state, token) {
            state.token = token
        },
        INIT_API_PARAMS(state){
            let subDomain = document.getElementById('app').dataset.domain
            if (subDomain.includes('staging.devops')){
                subDomain = 'staging'
            }

            state.token = localStorage.getItem('fitbase_token')
            state.subDomain = subDomain
        },
        SET_SETTINGS (state, data) {
            state.settings = data
        },
        SET_USER (state, data) {
            state.user = data
        },
        SET_RESERVATIONS (state, data) {
            state.reservations = data
        },
        SET_FINISHED_RESERVATIONS (state, data) {
            state.finishedReservations = data
        },
        SET_RESERVATIONS_TAB (state, data) {
            state.reservationsTab = data
        },
        SET_CONTRACTS (state, data) {
            state.contracts = data
        },
        SET_SERVICES (state, data) {
            state.services = data
        },
        SET_FINISHED_CONTRACTS (state, data) {
            state.finishedContracts = data
        },
        SET_FINISHED_SERVICES (state, data) {
            state.finishedServices = data
        },
        SET_SHOP_ITEM_CONTRACT_MODAL (state, data) {
            state.shopItemContractModal = data
        },
        SET_SHOP_ITEM_SERVICE_MODAL (state, data) {
            state.shopItemServiceModal = data
        },
        SET_SHOP_PAYMENT_MODAL (state, data) {
            state.shopPaymentModal = data
        },
        SET_SHOP_SUCCESS_MODAL (state, data) {
            state.shopSuccessModal = data
        },
        SET_SHOP_SALES (state, data) {
            state.shopSales = data
        },
        SET_SHOP_MAIN_CATEGORIES (state, data) {
            state.shopMainCategories = data
        },
        SET_ITEM_CANCEL_SUBSCRIPTION_MODAL(state, data) {
            state.itemCancelSubscriptionModal = data
        },
        SHOW_SUCCESS_MODAL(state, message) {
            state.successModal = true;
            state.successMessage = message;
        },
        HIDE_SUCCESS_MODAL(state) {
            state.successModal = false;
            state.successMessage = '';
        },
    },
    actions: {
        async loadSettings(){
            try {
                const data = (await api.settings.settings()).data;

                this.commit('SET_SETTINGS', data)
            }catch (e) {
                console.log(e)
            }
        },
        async loadUser(){
            try {
                this.commit('SHOW_PRELOADER')

                const user = (await api.user.getUser()).data;

                if (user[0] === null){
                    localStorage.removeItem('fitbase_token')
                    location.reload()
                }

                this.commit('SET_USER', user)

                this.commit('HIDE_PRELOADER')
            }catch (e) {
                if (e.response.status === 401 || e.response.status === 400){
                    localStorage.removeItem('fitbase_token')
                    location.reload()
                }
            }
        },
        async loadReservations(){
            const reservations = (await api.schedule.getReservations({
                params: {
                    available: 1,
                 //   active_records: 1,
                    pageSize: -1
                }
            })).data;
            this.commit('SET_RESERVATIONS', reservations)
        },
        async loadFinishedReservations(){
            const reservations = (await api.schedule.getReservations({
                params: {
                    expired: 1,
                    pageSize: -1
                }
            })).data;
            this.commit('SET_FINISHED_RESERVATIONS', reservations)
        },
        async loadContracts(){
            const contracts = (await api.contract.getContracts({
                params: {
                    pageSize: -1
                }
            })).data;
            this.commit('SET_CONTRACTS', contracts)
        },
        async loadServices(){
            const services = (await api.service.getServices({
                params: {
                    pageSize: -1
                }
            })).data;
            this.commit('SET_SERVICES', services)
        },
        async loadFinishedContracts(){
            const contracts = (await api.contract.getContracts({
                params: {
                    closed: 1,
                    pageSize: -1
                }
            })).data;
            this.commit('SET_FINISHED_CONTRACTS', contracts)
        },
        async loadFinishedServices(){
            const services = (await api.service.getServices({
                params: {
                    closed: 1,
                    pageSize: -1
                }
            })).data;
            this.commit('SET_FINISHED_SERVICES', services)
        },
        async loadShopSales(){
            const sales = (await api.shop.getSales()).data.items;
            this.commit('SET_SHOP_SALES', sales)
        },
        async loadShopMainCategories(){
            const sales = (await api.shop.getCategories()).data.items;
            this.commit('SET_SHOP_MAIN_CATEGORIES', sales)
        },
        closeModals(){
            this.commit('SET_SHOP_PAYMENT_MODAL', false)
            this.commit('SET_SHOP_SUCCESS_MODAL', false)
            this.commit('SET_SHOP_ITEM_CONTRACT_MODAL', false)
            this.commit('SET_SHOP_ITEM_SERVICE_MODAL', false)
            this.commit('SET_ITEM_CANCEL_SUBSCRIPTION_MODAL', false)
        },
        async optionsClub() {
            console.log(api.optionsClub);
            const clubs = await api.user.optionsClub();
            return clubs;
        }
    }
})